var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "member_tree"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('Input', {
    attrs: {
      "title": _vm._searchPlaceholder,
      "placeholder": _vm._searchPlaceholder,
      "clearable": ""
    },
    on: {
      "on-change": _vm.onChangeSearch
    },
    model: {
      value: _vm.searchValue,
      callback: function ($$v) {
        _vm.searchValue = $$v;
      },
      expression: "searchValue"
    }
  }, [_c('template', {
    slot: "prefix"
  }, [_c('span', {
    staticClass: "material-symbols-outlined",
    staticStyle: {
      "font-size": "18px",
      "line-height": "1",
      "color": "#a8a29e"
    }
  }, [_vm._v("search")])])], 2)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.treeData.length > 0,
      expression: "treeData.length > 0"
    }],
    staticClass: "member_tree_content"
  }, [_c('VirtualTree', {
    ref: "virtualTree",
    attrs: {
      "data": _vm.treeData
    },
    on: {
      "onChange": _vm.onChange,
      "onDelete": _vm.onDelete,
      "onAdd": _vm.onAddDepartmemt,
      "onEdit": _vm.onEditDepartmemt
    }
  })], 1), _c('DepartmentAdd', {
    attrs: {
      "data": _vm.treeData,
      "node": _vm.departmemt.node,
      "edit": _vm.departmemt.edit
    },
    on: {
      "onSuccess": _vm.onSuccessEdit
    },
    model: {
      value: _vm.departmemt.visible,
      callback: function ($$v) {
        _vm.$set(_vm.departmemt, "visible", $$v);
      },
      expression: "departmemt.visible"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };